import React, { useRef } from "react";
import { Container, Stack } from "@mui/material";

import { Header } from "src/widgets/Header";
import {
  AboutUsPage,
  ContactsPage,
  HomePage,
  ProjectsPage,
  ServicesPage,
} from "src/pages";
import { CopyRight } from "src/widgets/CopyRight";

export const Dashboard: React.FC = () => {
  const containerRef = useRef<HTMLDivElement>(null);

  return (
    <Stack
      width={1}
      minHeight="100vh"
      bgcolor="background.paper"
      direction="column"
      justifyContent="flex-start"
      alignItems="center"
    >
      <Container
        ref={containerRef}
        maxWidth="lg"
        sx={{
          width: 1,
          height: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "center",
          gap: {
            md: 12,
            xs: 8,
          },
        }}
      >
        <Header />

        <HomePage />
        <ServicesPage />
        <AboutUsPage />
        <ProjectsPage />
        {/*<BlogsPage />*/}
        <ContactsPage />

        <CopyRight />
        {/*<Outlet />*/}
      </Container>
    </Stack>
  );
};
